import API from './apiConfig';

export const getInterviewForm = async () => {
  const id = localStorage.getItem("participant_id")
    ? JSON.parse(localStorage.getItem("participant_id"))
    : "0000";
  try {
    const response = await API.get(`/interview/${id}`);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const getInterviewQuestion = async () => {
  const id = localStorage.getItem("participant_id")
    ? JSON.parse(localStorage.getItem("participant_id"))
    : "0000";
  try {
    const response = await API.get(`/interview_question/${id}`);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const postInterviewForm = async (formData) => {
  const id = localStorage.getItem("participant_id")
    ? JSON.parse(localStorage.getItem("participant_id"))
    : "0000";
  try {
    const response = await API.post(`/interview/${id}`, formData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateInterviewQuestion = async (formData) => {
  const id = localStorage.getItem("participant_id")
    ? JSON.parse(localStorage.getItem("participant_id"))
    : "0000";
  try {
    const response = await API.put(`/question/${id}`, formData);
    return response.data;
  } catch (error) {
    throw error;
  }
};